/*
 * Lib Module Tooltips
 */

class Tooltip extends LibModule {

    DOMReady() {
        this.bindTooltips($('[data-tooltip]'));
    }

    /**
     * Bind the tooltips
     * @param tooltips
     */
    bindTooltips(tooltips) {
        tooltips.not('.tooltipstered, .vscomp-clear-button, .vscomp-option, .vscomp-option-text, .vscomp-value').each(function() {
            let content = $(this).data('tooltip');

            if ($.trim(content) !== '') {

                $(this).tooltipster({
                    theme: $(this).data('tooltip-theme') || 'tooltipster-appo',
                    delay: $(this).data('tooltip-delay') || 300,
                    speed: $(this).data('tooltip-speed') || 350,
                    maxWidth: 650,
                    animation: $(this).data('tooltip-animation') || 'fade',
                    content: content,
                    side: $(this).data('tooltip-side') || 'top',
                    interactive: true,
                    contentAsHTML: true,
                    trigger: 'custom',
                    triggerOpen: {
                        mouseenter: true,
                        click: true,
                        tap: true
                    },
                    triggerClose: {
                        mouseleave: true,
                        tap: true,
                        scroll: true
                    }
                });
                // $(this).attr('onclick', 'return true');
            }
        });
    };

    disableTooltips(tooltips) {
        if (typeof tooltips === 'undefined') {
            tooltips = $('[data-tooltip].tooltipstered');
        }

        tooltips.each(function() {
            $(this).tooltipster('disable');
        });
    }

    enableTooltips(tooltips) {
        if (typeof tooltips === 'undefined') {
            tooltips = $('[data-tooltip].tooltipstered');
        }

        tooltips.each(function() {
            $(this).tooltipster('enable');
        });
    }

    closeAll() {
        $('[data-tooltip].tooltipstered').tooltipster('close');
    };
}

Lib.Tooltip = new Tooltip;
